import { WebContentSearchDto } from 'src/app/web-content/shared/dto/web-content-search.dto';
import { ProfileRead } from 'src/app/profiles/shared/profile-read.model';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ProfileService } from '../shared/profile.service';
import { UserService } from '../../users/shared/user.service';

@Component({
  selector: 'wl-profile-web-content',
  templateUrl: './profile-web-content.component.html',
  styleUrls: ['./profile-web-content.component.less'],
    standalone: false
})
export class ProfileWebContentComponent implements OnInit, OnDestroy {
  profileId: number;
  profile: ProfileRead;
  webContentSearchParams: WebContentSearchDto;
  isReadOnly = true

  private _routeSubscription: Subscription;
  constructor(private _route: ActivatedRoute, private _profileService: ProfileService, private _userService: UserService) {}

  ngOnInit() {
    this._routeSubscription = this._route.params.subscribe(params => {
      this.profileId = parseInt(params.id, 10);
      this.loadProfile();
      this.webContentSearchParams = new WebContentSearchDto(this.profileId, true);
    });
    let p8: any = this._userService.getCurrentUserSecurityElementAccessLevel('Web_Content_Management').then((accessLevel: number) => {
      if(accessLevel == 2)
      this.isReadOnly = false;
    })
  }

  ngOnDestroy() {
    if (this._routeSubscription) {
      this._routeSubscription.unsubscribe();
    }
  }

  private loadProfile() {
    this._profileService.getProfile(this.profileId).then(profile => {
      this.profile = profile;
    });
  }
}
